import BaseContainer from '@components/common/atoms/container/BaseContainer';
import RestaurantOfferStore from '@components/offer/stores/RestaurantOfferStore';
import LocalPhoneTwoToneIcon from '@mui/icons-material/LocalPhoneTwoTone';
import LocationOnTwoToneIcon from '@mui/icons-material/LocationOnTwoTone';
import { Box, Grid, IconButton, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';
import RestaurantBasicInfo from './RestaurantBasicInfo';

interface RestaurantDetailsProps {
    restaurantOfferStore: RestaurantOfferStore
}

const RestaurantDetails: React.FC<RestaurantDetailsProps> = observer(({ restaurantOfferStore }) => {
    const { selectedRestaurant } = restaurantOfferStore

    if (selectedRestaurant === undefined) {
        return null;
    }

    return (
        <>
            <Box
                sx={(theme) => ({
                    // position: "absolute",
                    // top: 0,
                    // left: 0,
                    mt: {
                        xs: "-72px",
                        sm: "-80px",
                        md: "-96px",
                        lg: "-112px"
                    },
                    backgroundImage: `url(${process.env.REACT_APP_RESTAURANT_IMAGES_URL}/${selectedRestaurant.id}.jpg)`,
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                    height: { xs: 260, md: 320 },
                    // [theme.breakpoints.up("sm")]: {
                    //     height: 260,
                    // },
                    // [theme.breakpoints.up("md")]: {
                    //     height: 320,
                    // },
                })}
                width={"100vw"}
                marginLeft={"calc(50% - 50vw)"}>
                <Grid
                    sx={{
                        // backdropFilter: "blur(6px)",
                        // backgroundColor: "#373737a6",
                        backgroundColor: "#22222299"
                    }}
                    container
                    direction={"column"}
                    alignItems={"center"}
                    justifyContent={"flex-end"}
                    width={"100%"}
                    height={"100%"}>
                    <BaseContainer useLeftAndRightPadding>
                        {/* <Paper
                        elevation={5}
                        sx={{
                            p: { xs: 2, sm: 4 }
                        }}> */}
                        <Box pb={2}>
                            <Box display={"flex"} flexDirection={'row'} justifyContent={"space-between"} alignItems={"center"}>
                                <Typography variant='h3' color={"#fff"} fontWeight={600}>{selectedRestaurant.name}</Typography>

                                <IconButton
                                    sx={{
                                        bgcolor: "#252525ba",
                                        display: { sm: "none" }
                                    }}
                                    color='secondary'
                                    onClick={() => window.open(`tel:${selectedRestaurant.phoneNumber}`)}>
                                    <LocalPhoneTwoToneIcon sx={{ color: "#fff" }} fontSize='small' />
                                </IconButton>
                            </Box>
                            <Box color={"#fff"} display={"flex"} flexDirection={"row"} flexWrap={"wrap"}>
                                <LocationOnTwoToneIcon fontSize='small' />
                                <Typography mr={2} variant='caption' >
                                    {selectedRestaurant.address}
                                </Typography>
                            </Box>
                            <RestaurantBasicInfo restaurant={selectedRestaurant} />
                        </Box>
                        {/* </Paper> */}
                    </BaseContainer>
                </Grid>
            </Box >
        </>
    )
})

export default RestaurantDetails;